import axios from "axios";

export function getToken(sessionId) {
    return axios.get(process.env.REACT_APP_AUTH_HOST_URL + '/v1/exchange', {
        headers: {'Authorization': 'Bearer ' + sessionId
    }
    });
 }